<template>
    <a class="resource"
       v-if="resource"
       href="#"
       @click.prevent.stop="action()"
       :class="`type-${resource.type}`"
       :style="`background-color: ${background_color}`">

        <div class="inner">

            <div :title="resource.name" class="image">
                <img :src="absolute_canvas_preview_url" alt="">
            </div>

            <div v-if="resource.name" class="title">
                {{ resource.name }}
            </div>

            <div v-if="resource.owner !== 'user'" class="owner">
<!--                {{ resource.owner }}-->
                Resource
            </div>

            <div v-if="icon" class="icon">
                <img :src="icon" alt="">
            </div>

        </div>

        <modal :id="utils.randomId({prefix: 'modal'})"
               @click.stop.prevent=""
               :show="show_modal"
               :size="is_previewable_in_modal ? 'xl' : 'md'"
               v-if="show_modal"
               @close="show_modal = false">
            <template #title>
                {{ resource.name }}
            </template>

<!--            <iframe v-if="is_previewable_in_modal"-->
<!--                    :src="uploads.url( preview_url )"-->
<!--                    frameborder="0"-->
<!--                    class="frame"></iframe>-->

            <template v-if="resource.data?.type === 'embed'">
                <div class="frame-wrapper" v-html="resource.data?.url"></div>
            </template>
            <div v-else-if="is_previewable_in_modal">
                <iframe v-if="resource.data?.file && resource.data?.file?.mime === 'application/pdf'"
                        :src="uploads.url( resource.data.file.url ) + '#toolbar=0&navpanes=0&scrollbar=0'"
                        frameborder="0"></iframe>
                <div v-else-if="preview_url">
                    <a :href="absolute_resource_url" target="_blank">
                        <img class="img-fluid mb-3" :src="uploads.url( preview_url )" alt="">
                    </a>
                </div>
            </div>
            <div v-else class="text-center my-5">
                <p>This resource can only be visible in a new window or must be downloaded first.</p>
                <a v-if="!is_previewable_in_modal"
                   :href="absolute_resource_url"
                   target="_blank"
                   type="button"
                   class="btn btn-success btn-lg">Download / Open in new Window</a>
            </div>

            <template #footer>
<!--                <button type="button"-->
<!--                        @click.prevent.stop="show_modal = false"-->
<!--                        class="btn btn-warning">Close</button>-->
                <a v-if="resource.data?.type !== 'embed' && is_previewable_in_modal"
                   :href="absolute_resource_url"
                   target="_blank"
                   type="button"
                   class="btn btn-success">Download / Open in new Window</a>
            </template>
        </modal>

    </a>
</template>

<script>
import API from "@/API";
import utils from "@/mixins/utils";
import Modal from "@/Components/Common/Modal";
import uploads from "@/mixins/uploads";

export default {
    name: "CanvasResource",
    props: ['resource'],
    emits: ['remove-resource'],
    components: {Modal},
    mixins: [utils, uploads],


    data(){
        return {
            show_modal: false,
        }
    },

    computed: {

        icon(){
            try{
                switch (this.resource.data.type){
                    case 'link':      return '/images/icons/globe.svg';
                    case 'file':      return '/images/icons/file';
                }
            }catch (e){}
            return '';
        },

        options(){
            return this.resource?.data?.options;
        },

        background_color(){
            try{ return this.resource.data.color; } catch (e){}
            return '#343a40';
        },

        absolute_resource_url(){
            if( this.resource.data?.type === 'file' ){
                return this.uploads.url( this.resource.data.file.url );
            }
            return this.resource.data.url;
        },


        absolute_canvas_preview_url(){

            let url = 'https://via.placeholder.com/480x480?text=PREVIEW+NOT+AVAILABLE';
            let w = 300;
            let h = 300;

            if( this.options?.width ){
                w = h * parseInt(this.options?.width);
            }

            if( this.preview_url ){
                url = this.uploads.image( this.uploads.url( this.preview_url ), {w, h} );
            }

            return url;

        },

        preview_url(){
            if( this.resource.data?.preview_url ) return this.resource.data?.preview_url;
            if( this.resource.data?.preview_file?.preview_url ) return this.resource.data?.preview_file?.preview_url;
            if( this.resource.data?.file?.preview_url ) return this.resource.data?.file?.preview_url;
            return null;
        },

        is_previewable_in_modal(){
            return this.resource.data?.type === 'embed' || !! this.preview_url;
            // try { return ['file'].filter( i => this.resource.data.type === i ).length > 0; }catch (e) {}
            // return false;
        },

    },


    methods: {
        action(){
            this.show_modal = true;
        },

        remove(){
            if( !confirm('Are you sure to remove this resource?') ) return;
            this.$emit('remove-resource');
            this.show_modal = false;
        },

    },

}
</script>

<style lang="scss" scoped>
.resource{
    border: #FFFFFF solid 2px;
    display: block;
    color: white;
    text-decoration: none;
    position: relative;
    width: 100%;
    border-radius: 0.4rem;
    overflow: hidden;
    box-shadow: 0 2px 8px #00000029;
}

.aw-1{
    .resource{
        padding-top: 100%;
    }
}

.aw-2{
    .resource{
        padding-top: 50%;
    }
}
.aw-3{
    .resource{
        padding-top: 33.333333%;
    }
}
.aw-4{
    .resource{
        padding-top: 25%;
    }
}
.aw-5{
    .resource{
        padding-top: 20%;
    }
}

.inner{
    padding: 1rem 1rem 2.6rem 1rem;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.title{
    position: relative;
    z-index: 1;
    padding: 0.5rem;
    background: rgba(white, 0.7);
    display: inline-block;
    border-radius: 0.3rem;
    color: $dark;
    backdrop-filter: blur(3px);
}

@media (min-width: 650px) and (max-width: 1199px){
    .aw-1{
        .resource{
            padding-top: 0%;
            padding-bottom: 100%;
        }
    }

    .aw-2{
        .resource{
            padding-top: 50%;
            padding-bottom: 50%;
        }
    }
    .aw-3{
        .resource{
            padding-top: 33.333333%;
            padding-bottom: 33.333333%;
        }
    }
    .aw-4{
        .resource{
            padding-top: 25%;
            padding-bottom: 25%;
        }
    }
    .aw-5{
        .resource{
            padding-top: 20%;
            padding-bottom: 20%;
        }
    }

    .title{
        position: static;
        padding: 1rem;

    }

    .inner{
        padding: 1rem;
        position: static;
    }
}

.image{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.icon{
    position: absolute;
    bottom: 0.6rem;
    right: 0.6rem;
}
.owner{
    position: absolute;
    background: #ee1651;
    color: white;
    bottom: 0;
    left: 0;
    border-radius: 0 0.4rem 0 0.4rem;
    padding: 0.2rem 0.5rem;
    text-transform: uppercase;
}
.sortable-ghost{
    .resource{
        background: rgba($dark, 0.3) !important;
        border-color: $dark !important;
        > * {
            opacity: 0.5 !important;
        }
    }
}

iframe{
    width: 100%;
    height: 600px;
    height: 75vh;
}
</style>
